import { createContext, useContext } from 'react';

export interface MixpanelClient {
  track: (event: string, properties?: Record<string, unknown>) => void;
  identify: (distinctId: string, userProperties?: Record<string, unknown>) => void;
  reset: () => void;
  register: (properties: Record<string, unknown>) => void;
  setGroup: (
    groupType: string,
    groupKey: string,
    groupProperties?: Record<string, unknown>,
  ) => void;
  screen: (name: string, properties?: Record<string, unknown>) => void;
  optInTracking: () => void;
  optOutTracking: () => void;
  /**
   * The anonymous id this visitor is browsing under, before any identify().
   * Needed to stitch a pre-login session that finished in another browser.
   */
  getDeviceId?: () => string | undefined;
}

export interface MixpanelClientOptions {
  serverURL?: string;
  debug?: boolean;
}

export const noopMixpanel: MixpanelClient = {
  track: () => {},
  identify: () => {},
  reset: () => {},
  register: () => {},
  setGroup: () => {},
  screen: () => {},
  getDeviceId: () => undefined,
  optInTracking: () => {},
  optOutTracking: () => {},
};

export const MixpanelContext = createContext<MixpanelClient>(noopMixpanel);

export function useMixpanel(): MixpanelClient {
  return useContext(MixpanelContext);
}
